/* eslint-disable import/prefer-default-export */
import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getReports } from "api/services/user";
import { reportQueryKeys } from "./reportQueryKeys";

export const useGetReport = (filters: string) => {
  const [isRefetchEnabled, setIsRefetchEnabled] = useState(false);
  const [startTime, setStartTime] = useState<null | number>(null);

  const query = useQuery({
    queryKey: reportQueryKeys.reportListing(filters),
    queryFn: ({ signal }) => getReports({ params: filters, signal }).then((res) => res.data),
    refetchInterval: isRefetchEnabled ? 10000 : false, // Refetching interval only when enabled
  });

  useEffect(() => {
    const res = query.data;
    if (!res) return;

    const isReportGenerating = res.results[0]?.status === "processing";

    // If a report is generating, enable refetching
    if (isReportGenerating) {
      setIsRefetchEnabled(true);

      // Set start time if not set, otherwise check if 1 minute has passed then disable refetching
      if (startTime === null) {
        setStartTime(Date.now());
      } else if (Date.now() - startTime > 60000) {
        setIsRefetchEnabled(false);
      }
    } else {
      // If no reports are generating, disable refetching
      setStartTime(null);
      setIsRefetchEnabled(false);
    }
  }, [query.data, startTime]);

  return query;
};
